export const StarIcon: React.FC<{ filled: boolean }> = ({ filled }) =>
  filled ? (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6406 1.84375C12.2031 0.71875 13.7969 0.765625 14.3125 1.84375L17.4062 8.07812L24.25 9.0625C25.4688 9.25 25.9375 10.75 25.0469 11.6406L20.125 16.4688L21.2969 23.2656C21.4844 24.4844 20.1719 25.4219 19.0938 24.8594L13 21.625L6.85938 24.8594C5.78125 25.4219 4.46875 24.4844 4.65625 23.2656L5.82812 16.4688L0.90625 11.6406C0.015625 10.75 0.484375 9.25 1.70312 9.0625L8.59375 8.07812L11.6406 1.84375Z"
        fill="#F4AC3F"
      />
    </svg>
  ) : (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.25 9.0625C25.4688 9.25 25.9375 10.75 25.0469 11.6406L20.125 16.4688L21.2969 23.2656C21.4844 24.4844 20.1719 25.4219 19.0938 24.8594L13 21.625L6.85938 24.8594C5.78125 25.4219 4.46875 24.4844 4.65625 23.2656L5.82812 16.4688L0.90625 11.6406C0.015625 10.75 0.484375 9.25 1.70312 9.0625L8.59375 8.07812L11.6406 1.84375C12.2031 0.71875 13.7969 0.765625 14.3125 1.84375L17.4062 8.07812L24.25 9.0625ZM18.4844 15.9062L24.0156 10.5625L16.375 9.4375L13 2.5L9.57812 9.4375L1.9375 10.5625L7.46875 15.9062L6.15625 23.5L13 19.9375L19.7969 23.5L18.4844 15.9062Z"
        fill="#787887"
      />
    </svg>
  );
